import { isNumber } from 'lodash';
import { formatSalePrice } from '../../../utils/money';
import { formatRaceName } from '../../../utils/name';

const getRow = (row, profileType, isIre) => {
    const res = {
        groupName: formatRaceName(row.groupName),
        wins: row.place1stNumber,
        runs: row.racesNumber,
        percent: isNumber(row.winPercent) ?
            row.winPercent : row.percent,
        placed: row.placed,
        stake: row.stake,
        totalEarnings: isIre
            ? formatSalePrice(row.euroTotalPrize, 'EUR')
            : formatSalePrice(row.totalPrize, 'GBP'),
    };

    if (profileType === 'jockey') {
        return {
            ...res,
            '2nd': row.place2ndNumber,
            '3rd': row.place3rdNumber,
            '4ths': row.place4thNumber,
            winnings: isIre
                ? formatSalePrice(row.euroWinPrize, 'EUR')
                : formatSalePrice(row.winPrize, 'GBP'),
        };
    }

    return {
        ...res,
        winsHorses: `${row.winners}/${row.horses}`,
        horseStyleName: row.horseName,
        horseUid: row.horseUid,
        rpr: row.bestRpPostmark,
    };
};

export default getRow;



// WEBPACK FOOTER //
// ./src/js/human/details/helpers/getRow.js